"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyAutoModuleAppModel = exports.createAutoModuleAppModel = void 0;
var Setting_1 = require("@microchip/scf-device/lib/Setting");
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var Utils_1 = require("../Utils");
var AutoModuleHelper = __importStar(require("./AutoModuleHelpers"));
var getConfigData_1 = require("./getConfigData");
var createAutoModuleAppModel = function (model, config) {
    return new MyAutoModuleAppModel(model, config);
};
exports.createAutoModuleAppModel = createAutoModuleAppModel;
var MyAutoModuleAppModel = /** @class */ (function () {
    function MyAutoModuleAppModel(model, config) {
        var _this = this;
        this.getModuleName = function () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            if (_this.moduleName)
                return _this.moduleName;
            _this.moduleName =
                (_h = (_f = (_d = (_c = (_b = (_a = _this.model.getDerivedFunctions()).moduleName) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : _this.model.getComponentValue("componentName")) !== null && _d !== void 0 ? _d : (_e = _this.model.getHardware()) === null || _e === void 0 ? void 0 : _e.getName()) !== null && _f !== void 0 ? _f : (_g = _this.config) === null || _g === void 0 ? void 0 : _g.moduleName) !== null && _h !== void 0 ? _h : "Module";
            return _this.moduleName;
        };
        this.getModuleCategory = function () {
            var _a, _b;
            return (_b = (_a = _this.model.getDerivedFunctions()).moduleCategory) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        this.createComponentList = function () {
            var componentList = {};
            var components = _this.getComponentList();
            var componentsWithDynamicDependencySelectors = __spreadArray(__spreadArray([], components, true), _this.getDefaultDependencySelectors(components), true);
            if (componentsWithDynamicDependencySelectors) {
                componentsWithDynamicDependencySelectors.forEach(function (component) {
                    componentList[component.name] = {
                        component: component,
                    };
                });
            }
            return componentList;
        };
        this.getAllComponents = function () { return _this.componentList; };
        this.getComponentList = function () {
            var _a, _b, _c, _d, _e;
            var components = [];
            var config = _this.config;
            if (!config)
                return components;
            //Software Components
            (_b = (0, Utils_1.values)((_a = config.softwareData) !== null && _a !== void 0 ? _a : {})) === null || _b === void 0 ? void 0 : _b.forEach(function (entry) {
                components.push(entry);
            });
            //Hardware Components
            (_c = config.peripherals) === null || _c === void 0 ? void 0 : _c.forEach(function (peripheral) {
                var _a;
                if (peripheral.registers) {
                    (_a = (0, Arrays_1.getKeys)(peripheral.registers)) === null || _a === void 0 ? void 0 : _a.forEach(function (registerName) {
                        var _a, _b;
                        (_b = (_a = peripheral.registers) === null || _a === void 0 ? void 0 : _a[registerName]) === null || _b === void 0 ? void 0 : _b.forEach(function (setting) {
                            var _a, _b;
                            //Only add hardware components that exist at runtime
                            var hardwareRegister = (_b = (_a = _this.model.getHardware()) === null || _a === void 0 ? void 0 : _a.getPeripheral().registers) === null || _b === void 0 ? void 0 : _b[registerName];
                            if (!(hardwareRegister === null || hardwareRegister === void 0 ? void 0 : hardwareRegister.settings) ||
                                hardwareRegister.settings[setting.setting] ||
                                hardwareRegister.type === "register") {
                                components.push(setting);
                            }
                        });
                    });
                }
            });
            //Custom Dynamic Components
            (_e = (_d = _this.model
                .getDerivedFunctions()).getDynamicComponents) === null || _e === void 0 ? void 0 : _e.call(_d).forEach(function (component) {
                components.push(component);
            });
            return components;
        };
        this.getActions = function (component) {
            var _a, _b, _c;
            return ((_c = (_b = (_a = _this.model.getDerivedFunctions()).getActions) === null || _b === void 0 ? void 0 : _b.call(_a, component.name)) !== null && _c !== void 0 ? _c : component.actions);
        };
        this.getDefaultComponentAction = function (componentName) {
            var _a;
            var component = (_a = _this.getComponent(componentName)) === null || _a === void 0 ? void 0 : _a.component;
            return {
                type: "[FORM] SUBMIT",
                payload: {
                    tabId: "main",
                    path: "".concat(component === null || component === void 0 ? void 0 : component.group, ".").concat(component === null || component === void 0 ? void 0 : component.name),
                    value: "%v",
                },
            };
        };
        this.getSoftwareComponentValue = function (tab, component) {
            var _a, _b, _c, _d;
            var overriddenValue = _this.model.getDerivedFunction(component.name);
            if (overriddenValue != undefined) {
                return overriddenValue;
            }
            if (_this.model.isControlledByInterface(component.name)) {
                var processedArg = _this.model
                    .getExportInterfaces()
                    .getProcessedArgValue(component.name);
                if (processedArg != undefined) {
                    return processedArg.value;
                }
            }
            return ((_d = (_c = (_b = (_a = _this.state) === null || _a === void 0 ? void 0 : _a[tab]) === null || _b === void 0 ? void 0 : _b[component.group]) === null || _c === void 0 ? void 0 : _c[component.name]) !== null && _d !== void 0 ? _d : AutoModuleHelper.getDefaultValue(_this.model.getDerivedFunctions().overrideDefaultValues, component));
        };
        this.getHardwareComponentValue = function (tab, component, setting) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (!_this.hardware)
                return undefined;
            var overriddenValue = _this.model.getDerivedFunction(component.name);
            if (overriddenValue != undefined) {
                return overriddenValue;
            }
            if (_this.model.isControlledByInterface(component.name)) {
                var processedArg = _this.model
                    .getExportInterfaces()
                    .getProcessedArgValue(component.name);
                if (processedArg != undefined) {
                    return processedArg.value;
                }
            }
            var overriddenCompValue = AutoModuleHelper.getOverrideDefaultValue(component, _this.model);
            var value; // value based on priority
            if (((_c = (_b = (_a = _this.state) === null || _a === void 0 ? void 0 : _a[tab]) === null || _b === void 0 ? void 0 : _b[component.group]) === null || _c === void 0 ? void 0 : _c[component.name]) != null) {
                value = _this.state[tab][component.group][component.name];
            }
            else if (overriddenCompValue !== undefined) {
                value = overriddenCompValue;
            }
            else {
                value =
                    setting !== undefined
                        ? component.overrideDefaultValue
                            ? component.overrideDefaultValue
                            : _this.getDefaultValue(component.displayOptionSetting, setting)
                        : (_d = component.overrideDefaultValue) !== null && _d !== void 0 ? _d : undefined;
            }
            //if filtered mode -> get options
            if (value != undefined && ((_e = component.mode) === null || _e === void 0 ? void 0 : _e.operation) === "filterOptions") {
                var options = AutoModuleHelper.getSettingOptionsIfPresent(component, setting, (_g = _this.model.getComponent((_f = component.mode) === null || _f === void 0 ? void 0 : _f.masterComponent)) === null || _g === void 0 ? void 0 : _g.value);
                if (options.indexOf(value) == -1) {
                    value = options[0];
                }
            }
            return value;
        };
        this.getHardwareComponentBooleanValue = function (tab, component, setting) {
            var _a, _b, _c;
            if (!_this.hardware)
                return undefined;
            var overriddenValue = _this.model.getDerivedFunction(component.name);
            if (overriddenValue != undefined) {
                return overriddenValue;
            }
            if (_this.model.isControlledByInterface(component.name)) {
                var processedArg = _this.model
                    .getExportInterfaces()
                    .getProcessedArgValue(component.name);
                if (processedArg != undefined) {
                    return processedArg.value;
                }
            }
            var overriddenCompValue = AutoModuleHelper.getOverrideDefaultValue(component, _this.model);
            return ((_c = (_b = (_a = _this.state) === null || _a === void 0 ? void 0 : _a[tab]) === null || _b === void 0 ? void 0 : _b[component.group]) === null || _c === void 0 ? void 0 : _c[component.name]) != null
                ? _this.state[tab][component.group][component.name]
                    ? _this.config.booleanValues.true
                    : _this.config.booleanValues.false
                : overriddenCompValue !== undefined
                    ? overriddenCompValue
                    : setting !== undefined
                        ? component.overrideDefaultValue
                            ? component.overrideDefaultValue
                            : _this.getDefaultValue(component.displayOptionSetting, setting)
                        : undefined;
        };
        this.getDependencyComponentValue = function (component) {
            var dependencySelector = new AutoModuleHelper.DependencySelector(_this.model, component);
            var imp = _this.model.getImports()[component.importId];
            if (imp === null || imp === void 0 ? void 0 : imp.handle) {
                return dependencySelector.createOptionLabel(imp.handle, imp.payload);
            }
            return "None";
        };
        this.getDefaultValue = function (optionType, setting) {
            var _a;
            if (optionType == undefined)
                return setting.defaultValue;
            if (setting.defaultValue) {
                return (_a = (0, Setting_1.getOptionByName)(setting.defaultValue, setting)) === null || _a === void 0 ? void 0 : _a[optionType];
            }
            return undefined;
        };
        this.model = model;
        this.state = this.model.getState();
        this.hardware = this.model.getHardware();
        this.config = (0, getConfigData_1.getConfigData)(model);
        this.componentList = this.createComponentList();
    }
    MyAutoModuleAppModel.prototype.getDefaultDependencySelectors = function (components) {
        var dynamicDependencySelectors = [];
        var defaultTab = "main";
        var defaultGroup = "software";
        if (components.length > 0) {
            defaultTab = components[0].tabs[0];
            defaultGroup = components[0].group;
        }
        var imports = this.model.getImports();
        if (imports) {
            var importedNames = Object.keys(imports);
            importedNames.forEach(function (name) {
                var _a;
                var dependencySelectors = components.filter(function (component) {
                    return component["importId"] && component["importId"] === name;
                });
                if (dependencySelectors.length === 0) {
                    dynamicDependencySelectors.push({
                        name: name + " dependency selector",
                        importId: name,
                        category: "import",
                        type: "ComboBox",
                        description: name + " dependency selector",
                        group: defaultGroup,
                        tabs: [defaultTab],
                        uiBehavior: (_a = {},
                            _a["ui:widget"] = "hidden",
                            _a),
                    });
                }
            });
        }
        return dynamicDependencySelectors;
    };
    MyAutoModuleAppModel.prototype.isComponent = function (componentName) {
        var _a;
        var component = (_a = this.componentList[componentName]) === null || _a === void 0 ? void 0 : _a.component;
        var componentValue = this.getComponentValue(componentName);
        if (component.category === "software") {
            if (component.type === "boolean") {
                return this.getComponentValue(componentName);
            }
            return componentValue !== undefined;
        }
        else if (component.category === "hardware") {
            return componentValue === this.config.booleanValues.true;
        }
        return undefined;
    };
    MyAutoModuleAppModel.prototype.getComponentValue = function (componentName) {
        var _a;
        return (_a = this.getComponent(componentName)) === null || _a === void 0 ? void 0 : _a.value;
    };
    MyAutoModuleAppModel.prototype.getComponent = function (componentName) {
        var _this = this;
        var _a, _b;
        if (((_a = this.componentList[componentName]) === null || _a === void 0 ? void 0 : _a.value) != undefined)
            return this.componentList[componentName];
        var component = (_b = this.componentList[componentName]) === null || _b === void 0 ? void 0 : _b.component;
        component === null || component === void 0 ? void 0 : component.tabs.forEach(function (tab) {
            if (component) {
                if (component.category === "software") {
                    _this.componentList[componentName].value =
                        _this.getSoftwareComponentValue(tab, component);
                }
                else if (component.category === "hardware") {
                    var setting = AutoModuleHelper.getSettingFromComponent(_this.model, component);
                    if (component.type === "boolean") {
                        _this.componentList[componentName].value =
                            _this.getHardwareComponentBooleanValue(tab, component, setting);
                    }
                    else {
                        _this.componentList[componentName].value =
                            _this.getHardwareComponentValue(tab, component, setting);
                    }
                }
                else if (component.category === "import") {
                    _this.componentList[componentName].value =
                        _this.getDependencyComponentValue(component);
                }
                _this.componentList[componentName].component.actions =
                    _this.getActions(component);
            }
        });
        return this.componentList[componentName];
    };
    return MyAutoModuleAppModel;
}());
exports.MyAutoModuleAppModel = MyAutoModuleAppModel;
//# sourceMappingURL=AutoModuleAppModel.js.map